import React from 'react';

import { InstanceProps } from '@/components/Modal';
import Typography from '@/components/Typography';
import { XIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface Props extends Pick<InstanceProps, 'close'> {}

const ModalHeader: React.FC<Props> = ({ close, children }) => (
  <div className="flex flex-row justify-between items-center">
    <Typography is="h6" size="lg" weight="bold">
      {children}
    </Typography>

    <Button variant="ghost" onClick={close}>
      <XIcon />
    </Button>
  </div>
);

export default ModalHeader;
